module.exports = __webpack_public_path__ + "img/up.24e47b5f.png";